/* eslint-disable no-console */

import { register } from "register-service-worker";

register("/sw.js", {
    ready() {
        console.log("[SW] Serving from cache.");
    },
    registered() {
        console.log("[SW] Registered.");
    },
    cached() {
        console.log("[SW] Content cached for offline use.");
    },
    updatefound() {
        console.log("[SW] New content downloading.");
    },
    updated() {
        console.log("[SW] New content available — please refresh.");
    },
    offline() {
        console.log("[SW] No internet connection. Running in offline mode.");
    },
    error(error) {
        console.error("[SW] Registration error:", error);
    },
});
